(function IIFE() {
    'use strict';

    /////////////////////////////

    function SocialActivityFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/social/activity/:methodKey', {}, {
            list: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'list',
                    ignore403: true,
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('SocialActivityFactory', SocialActivityFactory);
})();
